'use client';

import { c as _c } from "react/compiler-runtime";
import { getCurrencyByCode } from '@/config/currencies';
import { quickAmountTiers, type SelectQuickAmountsOptions, selectQuickAmounts } from './quick-amounts';
import { useFormattedCurrency } from './use-formatted-currency';
export interface QuickAmount {
  /** Local-currency value to fill into the (local) amount field. */
  value: number;
  /** Localised label for the button (e.g. "€25", "¥1,000"). */
  label: string;
}

/**
 * Quick-amount buttons for any money-entry surface (trade, boost, fund, gift).
 *
 * Returns curated round per-currency tiers (never the old €4 / €45 / €870
 * convert-then-snap output), capped by balance and taken low → mid. The
 * `value` is local, so the caller stores it in the local field and `toUsdc`
 * round-trips on submit.
 */
export function useQuickAmounts(t0) {
  const $ = _c(2);
  const opts = t0 === undefined ? {} : t0;
  const {
    currency,
    exchangeRate,
    formatQuickAmount
  } = useFormattedCurrency();
  const decimals = getCurrencyByCode(currency)?.decimals ?? 2;
  const tiers = quickAmountTiers(currency, exchangeRate, decimals);
  let t1;
  if ($[0] !== formatQuickAmount) {
    t1 = value => ({
      value,
      label: formatQuickAmount(value)
    });
    $[0] = formatQuickAmount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return selectQuickAmounts(tiers, {
    ...opts,
    decimals
  }).map(t1);
}